<div class="px-4 py-2 flex flex-col">
  @if (preNote(); as preNote) {
    <ng-container *ngTemplateOutlet="preNote" />
  }
  @if (selectionLabel(); as selectionLabel) {
    <div class="mb-3">
      <h5>{{ selectionLabel }}</h5>
    </div>
  }
  @if (showSelectAll()) {
    <label class="label">
      <input type="checkbox" class="checkbox checkbox-primary" (change)="onSelectAll()" [checked]="isAllSelected()" />Alle auswählen
    </label>
  }
  @if (showDeleteAll()) {
    <button class="btn btn-xs btn-secondary ml-auto" (click)="unselectAll()">Auswahl löschen</button>
  }
  @for (optionGroup of optionGroups(); track optionGroup.title) {
    <div class="flex flex-col gap-2 mt-2">
      <div class="flex items-center gap-x-1">
        <p class="text-sm font-semibold">{{ optionGroup.title }}</p>
        @if (optionGroup.description) {
          <span class="tooltip tooltip-right" [attr.data-tip]="optionGroup.description!">
            <ng-icon name="heroInformationCircleSolid" size="20" />
          </span>
        }
      </div>
      <div class="grid grid-cols-2 gap-x-6">
        @for (option of optionGroup.models; track option.name) {
          <label class="label flex items-center cursor-pointer">
            <input
              type="checkbox"
              [attr.data-testid]="'multi-select-option-' + option.name.replace(' ', '-')"
              class="checkbox checkbox-primary"
              [checked]="isSelected(option.object)"
              (change)="onCheckedChange($event, option.object)"
              [disabled]="disabledPreselectedOptions().includes(option.object)"
            />
            <span class="whitespace-nowrap">{{ option.name }}</span>
          </label>
        }
      </div>
    </div>
  }
  @if (footnote(); as footnote) {
    <ng-container *ngTemplateOutlet="footnote" />
  }
</div>
